import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TimesheetCalendarComponent } from './timesheet-calendar.component';
import { TimeViewComponent } from './time-view.component';

/**
 * Standalone module providing the reusable timesheet calendar grid and
 * time-entry cell components.
 *
 * Import this module in any feature module that needs to render or fill in a
 * timesheet calendar (e.g. the employee portal's submit/view screens).
 *
 * The client app continues to use its own local declarations of these
 * components so there is no selector conflict.
 */
@NgModule({
    declarations: [
        TimesheetCalendarComponent,
        TimeViewComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        TimesheetCalendarComponent,
        TimeViewComponent
    ]
})
export class TimesheetCalendarModule { }
